/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable i18next/no-literal-string */
import _ from 'lodash';
import { callNativeMethod } from 'src/mobile-ecomm/hooks/use-mobile-native-bridge';
import useStores from 'shared/hooks/use-stores';

let MXConnect: { load: typeof _.noop } | null = null;
let MxConnectEventHandler: ((type: string, payload: MXWidgetPayload) => void) | null = null;
let currentMXWidgetUrl: string | null = null;

export type MXWidgetPayload = {
  member_guid?: string;
  session_guid: string;
  user_guid: string;
};

export type MXWidgetProps = {
  mxWidgetUrl: string;
  onEvent: OnEventType['onEvent'];
};

type OnEventType = {
  onEvent: (type: string, payload: MXWidgetPayload) => void;
};

export type mxWidgetClientResponse = {
  loadMXWidget: ({ mxWidgetUrl: string }) => void;
  setMxConnectEventHandler: ({ onEvent }: OnEventType) => void;
};

export function MxWidgetClient(): mxWidgetClientResponse {
  const { DutchiePayEnrollment } = useStores();
  const setMxConnectEventHandler = ({ onEvent }: OnEventType): void => {
    MxConnectEventHandler = onEvent;
  };

  const loadMXWidget = async ({ mxWidgetUrl }): Promise<void> => {
    if (MXConnect !== null && currentMXWidgetUrl !== mxWidgetUrl) {
      MXConnect.load(mxWidgetUrl);
      currentMXWidgetUrl = mxWidgetUrl;
    } else if (MXConnect === null) {
      void (await initMXWidget());
      void loadMXWidget({ mxWidgetUrl });
    }
  };

  const initMXWidget = async (): Promise<void> => {
    const mobileEcommConfig = {
      is_mobile_webview: false,
      oauth_referral_source: 'APP',
      client_redirect_url: await callNativeMethod('getDutchiePayOAuthURL'),
    };

    const config = {
      // config options: https://docs.mx.com/api#connect_configuring_connect_configuration_scenarios
      ui_message_version: 4,
      widget_type: 'connect_widget',
      ...(DutchiePayEnrollment.isMobileEcommSignup && mobileEcommConfig),
    };

    MXConnect = new window.MXConnect({
      id: 'connect-widget',
      iframeTitle: 'Connect',

      onEvent(type, payload) {
        if (MxConnectEventHandler !== null) {
          MxConnectEventHandler(type, payload);
        }
      },
      config,
      targetOrigin: '*',
    });
  };

  return { loadMXWidget, setMxConnectEventHandler };
}
